import { fetcherWithToken } from '@/shared/api/fetcher';
import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';

async function updateUser(url, { arg }: { arg: string }) {
  return fetcherWithToken(url, {
    method: 'POST',
    body: arg,
  });
}
async function activateBonus(url, { arg }: { arg: string }) {
  const params = new URLSearchParams({ id: arg });
  return fetcherWithToken(`${url}?${params}`, {
    method: 'GET',
  });
}

const useProfile = () => {
  const { trigger, error } = useSWRMutation(
    '/profile/updateProfileData',
    updateUser
  );

  return {
    trigger,
  };
};

const useBonuses = () => {
  const {
    data,
    isLoading,
    mutate: mutateBonuses,
    error: isErrorBonuse,
  } = useSWR('/profile/getBonuses', fetcherWithToken, {
    dedupingInterval: 5000, // Не повторять запросы чаще 5 сек
    errorRetryCount: 1, // Максимум 1 повтор при ошибке
    shouldRetryOnError: false, // Отключить повтор при 500 ошибках
  });
  const { trigger: activate, error: activateError } = useSWRMutation(
    '/profile/activateBonus',
    activateBonus
  );
  const { trigger: deactivate, error: deactivateError } = useSWRMutation(
    '/profile/deactivateBonus',
    activateBonus
  );
  return {
    data,
    mutateBonuses,
    activate,
    deactivate,
    isLoading,
    isErrorBonuse,
  };
};

export { useProfile, useBonuses };
